<template>
  <div class="flex flex-wrap paddig-responsive">
    <div class="flex w-full text-left center-responsive">
      <h2>{{ $t("select_gender_question") }}</h2>
    </div>
    <div class="flex w-full mt-8">
      <div class="flex flex-col">
        <template v-for="option in options" :key="option.id">
          <label class="flex items-center mb-2">
            <input type="radio" :value="option.value" v-model="selectedGender" @change="showValue()" class="mr-2">
            <span>{{ option.label }}</span>
          </label>
        </template>
      </div>
    </div>
  </div>
</template>
  
<script lang="ts">
import { defineComponent } from 'vue';
import { SelectOption } from "@/custom-models/levelingSelector";
import { UserGender } from "@/enum/constants";
  
export default defineComponent({
  name: 'GenderSelector',
  props: {
    propGender:{ 
      type: Number,
      default: 0.1 
    }
  },
  created (){
    this.selectedGender = this.propGender;
  },
  data() {
    return {
      selectedGender: UserGender.MAN,
      options: [
        { id: 1, label: this.$t("male"), value: UserGender.MAN },
        { id: 2, label: this.$t("female"), value: UserGender.WOMAN },
      ] as SelectOption[]
    };
  },
  methods: {
    showValue() {
      this.$emit("selectedGender", this.selectedGender);
    }
  }
});
</script>